import * as types from "./actionTypes";
import minimaleEisenPerDossierApi from "../api/minimaleEisenPerDossierApi";
import * as constants from "../constants/DomainConstants";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as beads from "./beadActions";

// ----------------------------------------------------------------------------
export function minimaleEisenPerDossierLoaded(minimaleEisenPerDossier, errors, hasValidationErrors) {
	return {
		type: types.MINIMALE_EISEN_PER_DOSSIER_LOADED,
		body: {
			item: minimaleEisenPerDossier,
			errors: errors,
			hasValidationErrors: hasValidationErrors
		}
	};
}

export function loadMinimaleEisenPerDossier(dossierId) {
	return function (dispatch) {
		dispatch(ajax.started());

		return minimaleEisenPerDossierApi.getByDossier(dossierId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(minimaleEisenPerDossierLoaded(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

// ----------------------------------------------------------------------------
export function minimaleEisenPerDossierSaved(minimaleEisenPerDossier, errors, hasValidationErrors) {
	return {
		type: types.MINIMALE_EISEN_PER_DOSSIER_SAVED,
		body: {
			item: minimaleEisenPerDossier,
			errors: errors,
			hasValidationErrors: hasValidationErrors
		}
	};
}

export function saveMinimaleEisenPerDossier(minimaleEisenPerDossier, documenten) {
	return (dispatch) => {
		dispatch(ajax.started());

		return minimaleEisenPerDossierApi.save(minimaleEisenPerDossier, documenten)
			.then((response) => {
				dispatch(ajax.ended());

				if (response.data.concurrencyException) {
					dispatch(minimaleEisenPerDossierSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					return constants.HAS_CONCURRENCY_EXCEPTION;
				}

				if (response.data.hasValidationErrors) {
					dispatch(minimaleEisenPerDossierSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					return constants.HAS_VALIDATION_ERRORS;
				}

				if (Object.keys(response.data.validationResults).length !== 0) {
					dispatch(minimaleEisenPerDossierSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					dispatch(beads.beadsLoaded(response.data.item.beadModels));
					return constants.HAS_VALIDATION_ERRORS_SAVED;
				}

				dispatch(minimaleEisenPerDossierSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));

				dispatch(beads.beadsLoaded(response.data.item.beadModels));
				return constants.SUCCESS;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}